import { LoadingWrapper } from '@components/display/loading/LoadingWrapper';
import { usePublicEventContext } from '@event/contexts/PublicEventContext';
import {
    EventDetailCardDates,
    EventDetailCardOnsite,
    EventDetailCardVirtual,
} from '@event/routes/public/EventDetail/EventDetailCard';
import { EventTypes } from '@event/types/event';
import { Box, Divider } from '@mui/material';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { EventDetailCardBadges } from './EventDetailCardBadges';

interface IEventDetailCardProps {
    RegisterElement: ReactElement;
}

const EventDetailCard = ({ RegisterElement }: IEventDetailCardProps) => {
    const { type } = useParams();
    const {
        event: { fetching: isEventFetching, data: event },
    } = usePublicEventContext();

    const eventType = type as EventTypes;

    return (
        <div className="bg-white rounded-xl md:min-w-[476px] pt-9 pb-4 md:px-7 z-10 h-fit lg:max-w-[489px]">
            <EventDetailCardDates />
            <Divider className="!my-4" />
            {eventType && [EventTypes.PRIVATE_VIRTUAL, EventTypes.PUBLIC_VIRTUAL].includes(eventType) ? (
                <>
                    <EventDetailCardVirtual />
                    <Divider className="!my-4" />
                </>
            ) : (
                <EventDetailCardOnsite />
            )}
            <EventDetailCardBadges />
            <Box
                className="flex-col gap-3 items-end px-3.5 md:px-0"
                sx={{
                    display: { xs: 'none', md: 'flex' },
                }}
            >
                <LoadingWrapper loading={!!isEventFetching}>{RegisterElement}</LoadingWrapper>
            </Box>
        </div>
    );
};

export { EventDetailCard };
